import React, { Fragment, useContext, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import Components from "../home/Components";
import {  useLocation, useParams } from 'react-router-dom';
import PortoBlock from "../../components/product/PortoBlock"
import ContentContext from '../../context/ContentContext'
import Breadcrumb from '../../wrappers/breadcrumb/Breadcrumb';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import LZString from 'lz-string';


const RenderCustomPage = () => {
  const homepageJson = useContext(ContentContext);
  const location = useLocation();
  const {pathname} = location;
  console.log(pathname)

  // const [contentData, setContentData] = useState(StaticContent);

  // useEffect(() => {

	// 	fetch(`${window.location.origin}/api/promo/purchase-order/store-config/Unique`)
	// 		.then(response => response.json())
	// 		.then(response => {
	// 			setContentData(response);
	// 		});
	// }, []);

    const { componentUrl } = useParams();


  const previewContent = new URLSearchParams(window.location.search).get('preview')

  const pageData = previewContent ? JSON.parse(LZString.decompressFromEncodedURIComponent(previewContent)) : homepageJson && homepageJson.content?.contentManagement?.data?.content?.items[0]?.pages.filter(data => `${componentUrl}` === data.url)[0]?.sections


  const allMenus = homepageJson?.content?.contentManagement?.data?.content?.items?.[0]?.menu.reduce((acc, item) => {
    acc.set(item?.mainUrl, item?.mainTitle)
    if (item?.menus && Array.isArray(item?.menus) && item?.menus.length > 0) {
      item.menus.forEach(menu => {
        menu.forEach(subMenu => {
          acc.set(subMenu?.url, subMenu?.shortCode)
        })
      })
    }
    return acc;
  } ,new Map())

  const foundedPageTitle = allMenus?.get(pathname) || ''

  return (
    <Fragment>
      <MetaTags>
        <title>JT Hanna</title>
        <meta
          name="description"
          content="Fashion home of flone react minimalist eCommerce template."
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + '/'}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>{pathname === '/pages/lightbulb' ? 'Lightbulb' : foundedPageTitle}</BreadcrumbsItem>

      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
      >
         <Breadcrumb />
        {/* <StoryMenu /> */}
        {/* hero slider */}
        {pathname === '/pages/lightbulb' ? Components({component: 'lightBulb'}) : pageData?.sort((a, b) => a.sort > b.sort ? 1 : -1).map((block) => Components(block))}
      </LayoutOne>
    </Fragment>
  );
};

export default RenderCustomPage;
